// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__OTPzV","pagination-text":"pagination_pagination-text__oBw_Z","pagination-btns":"pagination_pagination-btns__7ua4Q"};